import noImage from "../../../assets/no_image.jpg";
import { getImagePath } from "../../../utils/util";

export const NUTRI_GRADES = ["A", "B", "C", "D", "E"];

/** Official Nutri-Score colours. */
export const NUTRI_COLORS = { A: "#038141", B: "#85BB2F", C: "#FECB02", D: "#EE8100", E: "#E63E11" };

/** "85/100", or null when the product is not rated yet. */
export const formatScore = (score) => (score === null || score === undefined ? null : `${Math.round(score)}/100`);

/** "16.2 g" / "335 kcal" / "181 µg"; unknown -> "—". */
export function formatAmount(value, unit, dp = 1) {
  if (value === null || value === undefined) return "—";
  const rounded = unit === "kcal" ? Math.round(value) : Number(value.toFixed(dp));
  return `${rounded}${unit === "kcal" ? " kcal" : ` ${unit}`}`;
}

const inr = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 });
export const formatPrice = (amount) => (amount === null || amount === undefined ? "" : `₹${inr.format(amount)}`);

export const FILTER_LABELS = {
  ALL: "All",
  HIGH_PROTEIN: "High Protein",
  LOW_GI: "Low GI",
  ORGANIC: "Organic",
  GLUTEN_FREE: "Gluten Free",
};

export const SORT_LABELS = {
  relevance: "Relevance",
  eatprotein_score: "E-Protein Score",
  protein: "Protein: high to low",
  price_asc: "Price: low to high",
  price_desc: "Price: high to low",
};

export const ATTRIBUTE_LABELS = {
  ORGANIC: "Organic",
  GLUTEN_FREE: "Gluten Free",
  LOW_GI: "Low GI",
  UNPOLISHED: "Unpolished",
  NO_ADDITIVES: "No Additives",
  NATURAL: "100% Natural",
  FARM_FRESH: "Farm Fresh",
  VEGAN: "Vegan",
};

/** Product image URL on the admin image host, or the placeholder. */
export const imageUrl = (path) => (path ? getImagePath(path) : noImage);

/** Badge wording per EatProtein grade (grades come from the score engine). */
const GRADE_BADGES = {
  EXCELLENT: { text: "Excellent Choice", tone: "good" },
  VERY_GOOD: { text: "Very Good Choice", tone: "good" },
  GOOD: { text: "Good Choice", tone: "good" },
  MODERATE: { text: "Eat in Moderation", tone: "warn" },
  LIMIT: { text: "Eat Occasionally", tone: "bad" },
};

const TONES = {
  good: { color: "#0B8F3C", background: "#EAF8EF" },
  warn: { color: "#B26A00", background: "#FFF4DE" },
  bad: { color: "#C62828", background: "#FDECEC" },
};

/**
 * Health badge: the grade when the product is rated, else the strongest
 * protein claim from the label, else nothing.
 */
export function healthBadge(nutrition) {
  if (!nutrition) return null;
  const { health, labels = [] } = nutrition;
  const graded = GRADE_BADGES[health?.grade];
  if (graded) return { text: graded.text, ...TONES[graded.tone] };
  if (labels.includes("HIGH_PROTEIN")) return { text: "High Protein", ...TONES.good };
  if (labels.includes("SOURCE_OF_PROTEIN")) return { text: "Source of Protein", ...TONES.good };
  return null;
}
